package com.sweetlime.bingeamigo.presentation.features.auth

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.sweetlime.bingeamigo.repository.AuthRepository
import kotlinx.coroutines.Job
import kotlinx.coroutines.delay
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.isActive
import kotlinx.coroutines.launch

class EmailVerificationViewModel(
    private val repository: AuthRepository
) : ViewModel() {

    sealed class State {
        data object Watching : State()
        data object Verified : State()
        data class ManualCheckFailed(val message: String) : State()
    }

    private val _state = MutableStateFlow<State>(State.Watching)
    val state = _state.asStateFlow()

    private var pollingJob: Job? = null

    fun startPolling() {
        pollingJob?.cancel()
        _state.value = State.Watching
        pollingJob = viewModelScope.launch {
            while (isActive) {
                delay(3_000)
                runCatching { repository.reloadUser() }
                if (repository.isEmailVerified()) {
                    _state.value = State.Verified
                    break
                }
            }
        }
    }

    fun checkNow() {
        viewModelScope.launch {
            runCatching { repository.reloadUser() }
            if (repository.isEmailVerified()) {
                _state.value = State.Verified
            } else {
                _state.value = State.ManualCheckFailed(
                    "Email not confirmed yet. Please click the link in your inbox."
                )
            }
        }
    }

    fun dismissError() {
        _state.value = State.Watching
    }
}